"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageAbsorbedEventArgs = void 0;
const EventType_1 = require("../EventType");
class DamageAbsorbedEventArgs {
    constructor(damagedBy, damageAbsorbed) {
        this.damagedBy = damagedBy;
        this.damageAbsorbed = damageAbsorbed;
        this.__type = EventType_1.EventType.DamageAbsorbed;
        this.__typeName = "DamageAbsorbed";
    }
}
exports.DamageAbsorbedEventArgs = DamageAbsorbedEventArgs;
